import React from 'react'

export const Home = () => {
    return (
        <div className='container'>
            <div className='justify-content-center' />
        </div>
    )
}
